import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";

export default function MetricsIcon(props) {
  const width = props.width || 30;
  const height = props.height || 30;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0943 9.89841L9.81315 13.7003H4.4375C4.64683 11.1754 5.79766 8.82158 7.66164 7.10575C9.52562 5.38991 11.9665 4.4375 14.5 4.4375C17.0335 4.4375 19.4744 5.38991 21.3384 7.10575C23.2023 8.82158 24.3532 11.1754 24.5625 13.7003H18.7103C18.565 13.7003 18.4221 13.7379 18.2957 13.8095C18.1692 13.881 18.0634 13.9841 17.9886 14.1087L16.3357 16.8638L13.5982 10.0197C13.54 9.87399 13.4423 9.74747 13.3161 9.65434C13.1899 9.56122 13.0402 9.50519 12.8838 9.49259C12.7275 9.47998 12.5707 9.51129 12.4312 9.583C12.2917 9.6547 12.175 9.76394 12.0943 9.89841ZM16.9057 19.1862L19.1869 15.3843H24.5625C24.3532 17.9091 23.2023 20.263 21.3384 21.9788C19.4744 23.6947 17.0335 24.6471 14.5 24.6471C11.9665 24.6471 9.52562 23.6947 7.66164 21.9788C5.79766 20.263 4.64683 17.9091 4.4375 15.3843H10.2897C10.435 15.3843 10.5779 15.3467 10.7043 15.2751C10.8308 15.2035 10.9366 15.1005 11.0114 14.9759L12.6643 12.2207L15.4018 19.0675C15.46 19.2132 15.5578 19.3398 15.6841 19.4329C15.8105 19.5261 15.9603 19.5821 16.1167 19.5946H16.1841C16.3294 19.5945 16.4722 19.5569 16.5987 19.4854C16.7251 19.4138 16.8309 19.3107 16.9057 19.1862Z"
          fill="url(#paint0_linear_metrics)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_metrics"
            x1="4.4375"
            y1="8.82031"
            x2="14.1909"
            y2="28.6661"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
